import { hashString } from './hashString.es.js';

const createUniqueCustomProperty = (block, propertyName) => {
  const hash = hashString("design-system" + block + propertyName);
  return `--${block}-${propertyName}-${hash}`;
};
const createUniqueCustomProperties = (block, propertyNames) => {
  return propertyNames.reduce((accum, propertyName) => {
    accum[propertyName] = createUniqueCustomProperty(block, propertyName);
    return accum;
  }, {});
};

export { createUniqueCustomProperties, createUniqueCustomProperty };
//# sourceMappingURL=createUniqueCustomProperty.es.js.map
